import { useState } from "react";
import { createUseStyles } from "react-jss";
import Addicon from "@mui/icons-material/Add";
import { Button, Popin } from "$components";
import IntegratedOrdersPopin from "../../IntegratedOrdersPopin/IntegratedOrdersPopin";
import { EDBIntegratedOrders } from "$types/EDBIntegratedOrders";
import { useEdbDispatch } from "$containers/EDB/form/context/EdbContext";
import { ProductService } from "$services";
import { queryClient } from "$utils/queryClient";

const useStyles = createUseStyles(() => ({
  CreateEdbPage_Popin: {
    "& .MuiDrawer-paper": {
      width: "786px !important",
      overflowY: "unset !important",
    },
  },
}));

type Props = {
  companyId: string;
  dockyardId: string;
  integratedOrders: EDBIntegratedOrders;
  isAddingMaterial: boolean;
  setIntegratedOrders: any;
};

function AddOrderButton({
  companyId,
  dockyardId,
  integratedOrders,
  isAddingMaterial,
  setIntegratedOrders,
}: Props) {
  const classes = useStyles();
  const [isPopinAddOrderOpen, setIsPopinAddOrderOpen] =
    useState<boolean>(false);

  const dispatch = useEdbDispatch();

  const handleOnValidateOrders = async (
    integratedOrders: EDBIntegratedOrders
  ) => {
    setIntegratedOrders(integratedOrders);
    setIsPopinAddOrderOpen(false);

    const productsReferenceList = integratedOrders?.orderProducts?.map(
      ({ order, suborderProductId, suborderId }) => {
        const productRef = order.suborders
          .find((s) => s.id === suborderId)
          .suborderProducts.find((p) => p.id === suborderProductId).reference;
        return { productRef, company: order.company };
      }
    );

    const queryKey = [
      "getProductByReference",
      { $inreference: productsReferenceList.map((p) => p.productRef) },
      productsReferenceList[0].company,
    ];
    let product: any = await queryClient.getQueryData(queryKey);
    if (!product) {
      product = await queryClient.fetchQuery(
        queryKey,
        () =>
          ProductService.getProductByReference({
            $inreference: productsReferenceList.map((p) => p.productRef),
            company: productsReferenceList[0].company,
          }),
        {
          cacheTime: 60 * 1000,
        }
      );
      // checked all the refs to the same code, apparently, we never save it, no idea why
      // queryClient.setQueryData(queryKey, product);
    }

    dispatch({ type: "addOrders", payload: { productList: product.flat() } });
  };

  return (
    <>
      <Button
        color="secondary"
        onClick={() => {
          setIsPopinAddOrderOpen(true);
        }}
      >
        <Addicon />
        Ajout commande
      </Button>
      <Popin
        className={classes.CreateEdbPage_Popin}
        openPopin={isPopinAddOrderOpen}
        toggleDrawer={() => setIsPopinAddOrderOpen(false)}
      >
        <IntegratedOrdersPopin
          dockyardId={dockyardId}
          companyId={companyId}
          openPopin={isPopinAddOrderOpen}
          setOpenPopin={setIsPopinAddOrderOpen}
          onValidate={handleOnValidateOrders}
          initialIntegratedOrders={integratedOrders}
          isAddingMaterial={isAddingMaterial}
        />
      </Popin>
    </>
  );
}

export default AddOrderButton;
